// removed by extract-text-webpack-plugin
module.exports = {"menu":"_2D0GgjZ9","meniList":"_1IzjXvDh","toggle-btn":"_1fzppp4_","menu_link":"_3L7oiDGJ","menu_link__active":"_3UxazPqR"};